import { Branding, BrandingDisabledIf, DisabledPrompt, useModel } from "bcms-react";
import { MainNavItem, MainNavMenuItem } from "../..";
import "./styles.css";

/**
 * @name BID2132BMainNavItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 2132B.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID2132BMainNavItems/>
 *      </div>
 *  );
 * }
 */
export default function BID2132BMainNavItems(props) {
  const { branding, demos } = useModel();
  const { options } = branding;
  const openAccount = () => {
    let origVersion = branding.options.orig_version_abi22;
    if (origVersion !== "ORIG19") origVersion = "ORIG20";
    window.open(demos[origVersion], "_blank");
  };

  const newAccountsLink = <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountSummary"]}>
    <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
    <DisabledPrompt>
      <MainNavMenuItem label="eStatements" data-point="Nav_eStatements_Notices" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Positive Pay" data-point="Nav_Positive_Pay" />
    </DisabledPrompt>
    <BrandingDisabledIf id="orig_courseid_abi22" exp={value => value !== null && value !== undefined}>
      <MainNavMenuItem label="Open a New Account" data-point="Nav_Open_Account" onClick={openAccount} />
    </BrandingDisabledIf>
    <DisabledPrompt>
      <MainNavMenuItem label="Relationship Builder" data-point="Nav_Relationship_Builder" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Deposit Checks" data-point="Nav_Deposit_Checks" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Commercial Banking" data-point="Nav_Commercial_Banking" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Fee Schedule" data-point="Nav_Fee_Schedule" />
    </DisabledPrompt>
  </MainNavItem>;
  const newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={["/transfers", "/externalTransfers", "/transferActivity/scheduledTransfers", "/unlinkedTransferAccounts"]} >
    <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
    <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
    <Branding id="tn19_abi22" value="true">
      <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers" />
    </Branding>
    <MainNavMenuItem label="Other NFCU Accounts" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts" />
    <DisabledPrompt>
      <MainNavMenuItem label="In-Branch Transactions" data-point="Nav_In_Branch_Transactions" />
    </DisabledPrompt>
  </MainNavItem>;
  const achLinks = <MainNavItem label="ACH" data-point="Nav_ACH" activeRoutes={["/achParticipants", "/achTemplates", "/achActivity", "/achPassthru", "/achImport"]} >
  <Branding id="ach_participants_abi22" value="true">
      <MainNavMenuItem label="ACH Participants" route="/achParticipants" data-point="Nav_ACH_Participants" />
  </Branding>
  <Branding id="one_time_ach_abi22" value="true">    
          <MainNavMenuItem label="One-Time ACH Payment" route="/oneTimeACHWorkflow" data-point="Nav_One-Time_ACH_Payments" />
     
  </Branding>
  <Branding id="ach_templates_abi22" value="true">
      <MainNavMenuItem label="ACH Templates" route="/achTemplates" data-point="Nav_ACH_Templates" />
  </Branding>
  <Branding id="ach_activity_abi22" value="true">
      <MainNavMenuItem label="ACH Activity" route="/achActivity" data-point="Nav_ACH_Activity" />
  </Branding>
  <Branding id="ach_pass_thru_abi22" value="true">
      <MainNavMenuItem label="ACH Pass-Thru" route="/achPassthru" data-point="Nav_ACH_Pass-Thru" />
  </Branding>
  <Branding id="ach_import_abi22" value="true">
      <MainNavMenuItem label="Import" route="/achImport" data-point="Nav_Import" />
  </Branding>
</MainNavItem>;

  const paymentLink = <MainNavItem label="Payments" data-point="Nav_Payments" activeRoutes={["/payments", "/stopPayment"]}>
    <DisabledPrompt>
    <MainNavMenuItem label="Bill Payment Center" route="/payments" data-point="Nav_Pay_Bills" />
    </DisabledPrompt>
    <MainNavMenuItem label="Loan Payment Center" data-point="Nav_Loan_Payment_Center">
      <DisabledPrompt>
        <MainNavMenuItem label="Pay with External Account" data-point="Nav_Pay_with_External_Account" />
      </DisabledPrompt>
      <MainNavMenuItem label="Pay with NFCU Account" route="/transfers" data-point="Nav_Pay_with_NFCU_Account" />
    </MainNavMenuItem>
    <MainNavMenuItem label="Stop Payment" route="/stopPayment" data-point="Nav_Stop_Payments" />
  </MainNavItem>;

  const pfmLink = options.pfm21_courseID_abi22 === null
    ? <DisabledPrompt><MainNavItem label="My Finances" data-point="Nav_My_Finances" /></DisabledPrompt>
    : <MainNavItem label="My Finances" route="/myFinances" data-point="Nav_My_Finances" />;

  // END: Branded links declared here and returned in the component.

  return (
    <Branding id="bid_abi22" value="2132B">
      <div className="flex-container flex-horizontal bid-2132B-menu">
        {newAccountsLink}
        {newTransfersLink}
        {achLinks}
        {paymentLink}
        {pfmLink}
      </div>
    </Branding>
  );
}
